import { Grid, Typography, Box } from '@mui/material';
import { StatusChip } from '../../components/StatusChip';
import { MessageItem } from './types';
import { ticketEasyColors } from '../../TicketEasyTheme';

interface MessageInfoProps {
    dataItem: MessageItem;
}

export function MessageInfo({ dataItem }: MessageInfoProps) {
   
    return (
        <Grid container spacing={3} sx={{ mb: 2 }}>
            <Grid item xs={12} md={6}>
                <Box sx={{ mb: 2 }}>
                    <Typography variant="caption" sx={{ textTransform: 'uppercase', color: ticketEasyColors.psnAccent, fontWeight: 600 }}>
                        Created By
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 'bold', color: ticketEasyColors.psnBlue }}>
                        {dataItem.createdBy}
                    </Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                    <Typography variant="caption" sx={{ textTransform: 'uppercase', color: ticketEasyColors.psnAccent, fontWeight: 600 }}>
                        Created Date
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 'bold', color: ticketEasyColors.psnBlue }}>
                        {dataItem.createdDate}
                    </Typography>
                </Box>                      
            </Grid>
            <Grid item xs={12} md={6}>
                <Box sx={{ mb: 2 }}>
                    <Typography variant="caption" sx={{ textTransform: 'uppercase', color: ticketEasyColors.psnAccent, fontWeight: 600 }}>
                        Due Date
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 'bold', color: ticketEasyColors.psnBlue }}>
                        {dataItem.dueDate}
                    </Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                    <Typography variant="caption" sx={{ textTransform: 'uppercase', color: ticketEasyColors.psnAccent, fontWeight: 600 }}>
                        Status
                    </Typography>
                    <Box sx={{ mt: 0.5 }}>
                        <StatusChip status={dataItem.status} />
                    </Box>
                </Box>
            </Grid>
        </Grid>
    );
}